export default "__VITE_ASSET__Cyai1CoJ__"